import script from "./FileInfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileInfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./FileInfoModal.vue?vue&type=style&index=0&id=aaee824e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aaee824e"]])

export default __exports__